import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Tabs, Tab, Box } from "@material-ui/core";

import MainContainer from "../../components/MainContainer";
import Campaigns from "../Campaigns";
import ContactLists from "../ContactLists";
import CampaignsConfig from "../CampaignsConfig";
import FileLists from "../Files";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "hidden",
  },
  tabsBar: {
    backgroundColor: theme.palette.background.paper,
    borderBottom: "1px solid #e5e7eb",
    flexShrink: 0,
  },
  tabContent: {
    flex: 1,
    overflow: "auto",
    ...theme.scrollbarStyles,
  },
}));

const TABS = [
  { key: "campaigns",     label: "Campanhas" },
  { key: "contact-lists", label: "Listas de Contatos" },
  { key: "config",        label: "Configurações" },
  { key: "files",         label: "Arquivos" },
];

const Disparos = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  const params = new URLSearchParams(location.search);
  const tabParam = params.get("tab");
  const activeTab = TABS.find((t) => t.key === tabParam) ? tabParam : "campaigns";

  const handleTabChange = (_, newTab) => {
    history.push(`/disparos?tab=${newTab}`);
  };

  return (
    <MainContainer>
      <div className={classes.root}>
        <div className={classes.tabsBar}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
          >
            {TABS.map((t) => (
              <Tab key={t.key} value={t.key} label={t.label} />
            ))}
          </Tabs>
        </div>
        <Box className={classes.tabContent}>
          {activeTab === "campaigns"     && <Campaigns     embedded={true} />}
          {activeTab === "contact-lists" && <ContactLists  embedded={true} />}
          {activeTab === "config"        && <CampaignsConfig embedded={true} />}
          {activeTab === "files"         && <FileLists     embedded={true} />}
        </Box>
      </div>
    </MainContainer>
  );
};

export default Disparos;
